import React from 'react';

import TotalOutcome from '../outcomes/TotalOutcome.jsx';
import SlotName from './SlotName.jsx';

export default class TotalSlot extends React.Component {
    static propTypes = {
        section: React.PropTypes.string.isRequired,
        sportId: React.PropTypes.number.isRequired,
        match: React.PropTypes.object,
        slot: React.PropTypes.object.isRequired,
        outcomes: React.PropTypes.array.isRequired,
        gridLocalization: React.PropTypes.object.isRequired
    };

    static renderOutcome(outcome, section, gridLocalization) {
        return (<TotalOutcome key={outcome.get('id')} outcome={outcome} section={section} gridLocalization={gridLocalization} />);
    }

    shouldComponentUpdate(nextProps) {
        return this.props.gridLocalization !== nextProps.gridLocalization ||
            this.props.slot !== nextProps.slot ||
            this.props.outcomes !== nextProps.outcomes;
    }

    render() {
        const {section, sportId, match, slot, outcomes, gridLocalization} = this.props;

        const slotProps = {
            sportId,
            match,
            slot,
            outcome: outcomes[0],
            gridLocalization
        };

        return (
            <div className="table detailed long">
                <div className="row inner">
                    <div className="cell main">
                        <SlotName {...slotProps}/>
                    </div>

                    <div className="cell rate ss">
                        <div className="rates">
                            {outcomes.map((o) => TotalSlot.renderOutcome(o, section, gridLocalization))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/slots/TotalSlot.jsx